import React from 'react';

import Description from 'components/typography/Description';

const TimeToPrepareInputDescription = () => {
  return (
    <Description>
      How long does it take to prepare this recipe <b>overall</b> ?
    </Description>
  );
};

export default TimeToPrepareInputDescription;
